import React from "react";
import * as dateUtil from "../../../util/dateUtil";
import { INQUIRY_CATEGORY_MAP } from "../store/inquiryConstants";
import {dateTimeToStr} from "../../../util/dateUtil";

class InquirySearchEngine extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.today = dateUtil.dateTimeToStr(new Date()).slice(0, 10);
    }

    render() {
        const { setValue } = this.props;
        const { searchType, orderType, searchStartDate, searchEndDate, inquiryStatus} = this.props;

        return(
            <React.Fragment>
                <div className='search-box p-lg-2 p-2 pt-0 mb-3'>
                    <div className='row align-items-center'>
                        <div className='col-12 d-flex align-items-center flex-wrap gap-3'>
                            <div className="d-flex align-items-center">
                                <select
                                    className="form-select form-select-sm"
                                    style={{ width: '120px' }}
                                    value={orderType}
                                    onChange={(e) => setValue('orderType', e.target.value)}
                                >
                                    <option value="DESC">최신순</option>
                                    <option value="ASC">오래된 순</option>
                                </select>
                            </div>

                            {/* 2. searchStartDate 달력 ~ searchEndDate 달력 */}
                            <div className="d-flex align-items-center">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    style={{ width: '140px' }}
                                    value={searchStartDate}
                                    onChange={(e) => setValue('searchStartDate', e.target.value)}
                                    max={searchEndDate || this.today} // 종료일 or 오늘 날짜가 최대
                                />
                                <span className="mx-2">~</span>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    style={{ width: '140px' }}
                                    value={searchEndDate}
                                    onChange={(e) => setValue('searchEndDate', e.target.value)}
                                    min={searchStartDate} // 시작 날짜가 최소
                                    max={this.today} // 오늘 날짜가 최대
                                />
                            </div>

                            {/* 3. searchType 셀렉트 박스 (문의 유형) */}
                            <div className="d-flex align-items-center">
                                <select
                                    className="form-select form-select-sm"
                                    style={{ width: '140px' }}
                                    value={searchType}
                                    onChange={(e) => setValue('searchType', e.target.value)}
                                >
                                    <option value="0">문의 유형</option>
                                    {Object.entries(INQUIRY_CATEGORY_MAP).map(([key, value]) => (
                                        <option key={key} value={key}>
                                            {value}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* 4. inquiryStatus 셀렉트박스 (상태) */}
                            <div className="d-flex align-items-center">
                                <select
                                    className="form-select form-select-sm"
                                    style={{ width: '120px' }}
                                    value={inquiryStatus}
                                    onChange={(e) => setValue('inquiryStatus', e.target.value)}
                                >
                                    <option value="">상태 전체</option>
                                    <option value="WAIT">등록</option>
                                    <option value="ANSWER">답변완료</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default InquirySearchEngine;